"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var FollowingIndexWrapper = function FollowingIndexWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _Class;
  return (0, _mobxReact.observer)(_class = (_class2 = (_Class = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "email", _descriptor, _this);
      _initializerDefineProperty(_this, "message", _descriptor2, _this);
      _initializerDefineProperty(_this, "creatingFollowAssociation", _descriptor3, _this);
      _initializerDefineProperty(_this, "showMessage", _descriptor4, _this);
      _initializerDefineProperty(_this, "invitationId", _descriptor5, _this);
      _initializerDefineProperty(_this, "editMode", _descriptor6, _this);
      _initializerDefineProperty(_this, "finishedMatchInTreeNode", _descriptor7, _this);
      _initializerDefineProperty(_this, "receivedFinishedMatchInTreeNode", _descriptor8, _this);
      _initializerDefineProperty(_this, "receivedFollowAssociations", _descriptor9, _this);
      _this.getFollowAssociations();
      if (_this.props.treeNodeId) {
        _state.TreeUI.challengeStore.getIndex({
          filters: {
            challengee_finished_match: false,
            tree_node_id: _this.props.treeNodeId,
            user_id: _state.TreeUI.user.id
          }
        });
        _state.TreeUI.followAssociationStore.finishedMatchInTreeNode({
          queryStrings: {
            tree_node_id: _this.props.treeNodeId
          }
        }, _this.afterGetFinishedMatchInTreeNode);
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "showSpinner",
      get: function get() {
        return this.props.treeNodeId && !this.receivedFinishedMatchInTreeNode || !this.receivedFollowAssociations;
      }
    }, {
      key: "onCreateFollowing",
      value: function onCreateFollowing() {
        this.creatingFollowAssociation = true;
        _state.TreeUI.followAssociationStore.create({
          data: {
            email: this.email
          }
        }, this.afterCreateFollowing);
      }
    }, {
      key: "afterGetFinishedMatchInTreeNode",
      value: function afterGetFinishedMatchInTreeNode(resp) {
        this.receivedFinishedMatchInTreeNode = true;
        this.finishedMatchInTreeNode = resp['userIds'];
      }
    }, {
      key: "afterCreateFollowing",
      value: function afterCreateFollowing(params) {
        var _this2 = this;
        this.creatingFollowAssociation = false;
        if (params['alreadyFollowing']) {
          this.showMessage = 'already-following';
          this.email = '';
          setTimeout(function () {
            return _this2.showMessage = false;
          }, 5000);
        } else if (params['alreadyInvited']) {
          this.showMessage = 'already-invited';
          this.email = '';
          setTimeout(function () {
            return _this2.showMessage = false;
          }, 5000);
        } else if (params['invitationId']) {
          this.email = '';
          this.showMessage = 'message-sent';
          setTimeout(function () {
            return _this2.showMessage = false;
          }, 5000);
        } else {
          this.email = '';
          this.getFollowAssociations();
        }
      }
    }, {
      key: "getFollowAssociations",
      value: function getFollowAssociations() {
        _state.TreeUI.followAssociationStore.clearIndexData();
        _state.TreeUI.followAssociationStore.getIndex({
          limit: 10
        }, this.afterGetFollowAssociations);
      }
    }, {
      key: "afterGetFollowAssociations",
      value: function afterGetFollowAssociations(resp) {
        _state.TreeUI.followAssociationStore.setIndexData(resp);
        this.receivedFollowAssociations = true;
      }
    }, {
      key: "onRemoveFollowAssociation",
      value: function onRemoveFollowAssociation(followAssociationId) {
        _state.TreeUI.user.set('followingsCount', _state.TreeUI.user.followingsCount - 1);
        _state.TreeUI.followAssociationStore.destroy({
          ids: {
            followAssociationId: followAssociationId
          }
        }, this.getFollowAssociations);
      }
    }, {
      key: "updateEmail",
      value: function updateEmail(email) {
        if ((0, _utils.isBlank)(email)) {
          this.email = '';
          this.invitationId = null;
        } else {
          this.email = email;
        }
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          email: this.email,
          message: this.message,
          creatingFollowAssociation: this.creatingFollowAssociation,
          showMessage: this.showMessage,
          invitationId: this.invitationId,
          editMode: this.editMode,
          finishedMatchInTreeNode: this.finishedMatchInTreeNode,
          receivedFinishedMatchInTreeNode: this.receivedFinishedMatchInTreeNode,
          receivedFollowAssociations: this.receivedFollowAssociations,
          showSpinner: this.showSpinner,
          onCreateFollowing: this.onCreateFollowing,
          afterGetFinishedMatchInTreeNode: this.afterGetFinishedMatchInTreeNode,
          afterCreateFollowing: this.afterCreateFollowing,
          getFollowAssociations: this.getFollowAssociations,
          afterGetFollowAssociations: this.afterGetFollowAssociations,
          onRemoveFollowAssociation: this.onRemoveFollowAssociation,
          updateEmail: this.updateEmail
        }));
      }
    }]);
  }(_react["default"].Component), _Class.defaultProps = {
    iconColor: '#CECECE',
    closeIconMargin: 0
  }, _Class), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "email", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "message", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return '';
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "creatingFollowAssociation", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "showMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "invitationId", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "editMode", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "finishedMatchInTreeNode", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return [];
    }
  }), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "receivedFinishedMatchInTreeNode", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "receivedFollowAssociations", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showSpinner"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onCreateFollowing", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onCreateFollowing"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetFinishedMatchInTreeNode", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetFinishedMatchInTreeNode"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterCreateFollowing", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterCreateFollowing"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "getFollowAssociations", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "getFollowAssociations"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetFollowAssociations", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetFollowAssociations"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onRemoveFollowAssociation", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onRemoveFollowAssociation"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateEmail", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "updateEmail"), _class2.prototype), _class2)) || _class;
};
FollowingIndexWrapper.displayName = 'FollowingIndexWrapper';
var _default = exports["default"] = FollowingIndexWrapper;